import { render, staticRenderFns } from "./Database_improve_modal.vue?vue&type=template&id=b4b184d8"
import script from "./Database_improve_modal.vue?vue&type=script&lang=js"
export * from "./Database_improve_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports